import {ssrSafeWindow} from '@github-ui/ssr-utils'

// Container ID for measuring container width to match CSS container queries
export const DIFF_COMPARISON_VIEWER_CONTAINER_ID = 'diff-comparison-viewer-container'

// Container query breakpoint that matches the CSS @container (min-width: 1012px)
export const WIDE_MODE_CONTAINER_BREAKPOINT = 1012

/**
 * Measures the diff comparison viewer container width and returns
 * whether it meets the wide-mode threshold (>= 1012px).
 * Falls back to window.innerWidth if container has 0 width (JSDOM) or is not found.
 */
export function measureIsWideViewport(): boolean {
  if (typeof document === 'undefined') return false
  const container = document.getElementById(DIFF_COMPARISON_VIEWER_CONTAINER_ID)
  if (container) {
    const currentWidth = container.getBoundingClientRect().width
    if (currentWidth === 0 && ssrSafeWindow) {
      return ssrSafeWindow.innerWidth >= WIDE_MODE_CONTAINER_BREAKPOINT
    }
    return currentWidth >= WIDE_MODE_CONTAINER_BREAKPOINT
  }
  if (ssrSafeWindow) {
    return ssrSafeWindow.innerWidth >= WIDE_MODE_CONTAINER_BREAKPOINT
  }
  return false
}
